var _rect, _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 41,
    rx: 20.5,
    fill: "url(#paint0_linear_1494_501)",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_501)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.486 27L43.44 13.998H44.826L46.476 25.086L48.478 13.998H49.6L51.558 25.064L53.23 13.998H54.638L52.57 27H50.986L49.05 17.122L47.114 27H45.486ZM57.9409 27.154C57.6036 27.154 57.2589 27.1027 56.9069 27C56.5696 26.912 56.2763 26.6993 56.0269 26.362C55.7923 26.01 55.6749 25.4673 55.6749 24.734V23.678C55.6749 22.9447 55.8949 22.358 56.3349 21.918C56.7896 21.4633 57.4056 21.06 58.1829 20.708C58.6816 20.4587 59.0849 20.2387 59.3929 20.048C59.7156 19.8573 59.9576 19.6447 60.1189 19.41C60.2803 19.1753 60.3609 18.86 60.3609 18.464V18.002C60.3609 17.65 60.2876 17.3787 60.1409 17.188C59.9943 16.9973 59.7963 16.8653 59.5469 16.792C59.3123 16.7187 59.0629 16.682 58.7989 16.682C58.1389 16.682 57.7063 16.8653 57.5009 17.232C57.2956 17.584 57.1929 18.112 57.1929 18.816V19.74H55.9389V18.684C55.9389 18.1413 56.0123 17.6647 56.1589 17.254C56.3056 16.8287 56.5843 16.4987 56.9949 16.264C57.4056 16.0147 58.0069 15.89 58.7989 15.89C59.6349 15.89 60.2583 15.9853 60.6689 16.176C61.0943 16.3667 61.3729 16.638 61.5049 16.99C61.6516 17.342 61.7249 17.76 61.7249 18.244V27H60.3829L60.3609 25.636C60.1849 26.1347 59.8696 26.516 59.4149 26.78C58.9603 27.0293 58.4689 27.154 57.9409 27.154ZM58.4469 26.23C59.1069 26.23 59.5836 25.9953 59.8769 25.526C60.1849 25.0567 60.3389 24.4333 60.3389 23.656V20.18C60.1923 20.4147 59.9503 20.6273 59.6129 20.818C59.2756 21.0087 58.9309 21.1993 58.5789 21.39C58.0803 21.6833 57.6916 21.9913 57.4129 22.314C57.1489 22.622 57.0169 23.0547 57.0169 23.612V24.47C57.0169 24.998 57.0903 25.3867 57.2369 25.636C57.3836 25.8853 57.5669 26.0467 57.7869 26.12C58.0069 26.1933 58.2269 26.23 58.4469 26.23ZM66.2212 27.022C65.8985 27.022 65.6052 26.9853 65.3412 26.912C65.0772 26.8387 64.8498 26.7213 64.6592 26.56C64.4685 26.384 64.3218 26.164 64.2192 25.9C64.1165 25.6213 64.0652 25.2767 64.0652 24.866V16.968H63.0972V16.264L64.1532 16.11L64.3952 14.064H65.4292V16.11H67.7832V16.968H65.4292V24.624C65.4292 25.0347 65.5025 25.3793 65.6492 25.658C65.7958 25.9367 66.1185 26.076 66.6172 26.076C66.8225 26.076 67.0425 26.0687 67.2772 26.054C67.5118 26.0247 67.6805 26.01 67.7832 26.01V26.89C67.6658 26.89 67.4605 26.912 67.1672 26.956C66.8738 27 66.5585 27.022 66.2212 27.022ZM71.9678 27.198C71.2491 27.198 70.6625 27.1173 70.2078 26.956C69.7531 26.78 69.4231 26.472 69.2178 26.032C69.0125 25.5773 68.9098 24.9173 68.9098 24.052V18.684C68.9098 17.6133 69.1371 16.8873 69.5918 16.506C70.0611 16.11 70.8311 15.912 71.9018 15.912C72.9431 15.912 73.6911 16.1027 74.1458 16.484C74.6151 16.8653 74.8498 17.5693 74.8498 18.596V20.026H73.4858V18.552C73.4858 17.9213 73.3831 17.4667 73.1778 17.188C72.9725 16.8947 72.5471 16.748 71.9018 16.748C71.2565 16.748 70.8238 16.8947 70.6038 17.188C70.3838 17.4667 70.2738 17.9213 70.2738 18.552V24.404C70.2738 25.108 70.3838 25.6067 70.6038 25.9C70.8238 26.1787 71.2711 26.318 71.9458 26.318C72.5618 26.318 72.9725 26.1787 73.1778 25.9C73.3831 25.6213 73.4858 25.1227 73.4858 24.404V22.93H74.8498V24.052C74.8498 24.888 74.7471 25.5333 74.5418 25.988C74.3365 26.4427 74.0211 26.758 73.5958 26.934C73.1705 27.11 72.6278 27.198 71.9678 27.198ZM76.8008 27V13.14H78.0988V17.012C78.2748 16.6747 78.5388 16.4107 78.8908 16.22C79.2428 16.0147 79.6901 15.912 80.2328 15.912C81.0101 15.912 81.5748 16.0513 81.9268 16.33C82.2934 16.594 82.5281 16.946 82.6308 17.386C82.7334 17.8113 82.7848 18.2807 82.7848 18.794V27H81.4208V18.992C81.4208 18.772 81.4134 18.5447 81.3988 18.31C81.3841 18.0607 81.3254 17.8333 81.2228 17.628C81.1348 17.4227 80.9808 17.254 80.7608 17.122C80.5408 16.9753 80.2181 16.902 79.7928 16.902C79.4114 16.902 79.0961 16.968 78.8468 17.1C78.6121 17.2173 78.4361 17.3567 78.3188 17.518C78.2161 17.6793 78.1648 17.8187 78.1648 17.936V27H76.8008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 21.1L16 15V27.5",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.6008L16.3 27.4008L17.3 26.8008",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.0992L24 22.6992",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.16 3.16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3999 21.8004L26.0999 21.4004L26.5499 21.1504",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_501",
    x1: 3,
    y1: 15.6341,
    x2: 85.4847,
    y2: 20.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1097C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57366,
    stopColor: "#16769E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1097C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_501",
    x1: 2.85393,
    y1: 15.9024,
    x2: 38.1805,
    y2: 16.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1097C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57366,
    stopColor: "#78ADC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1097C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/Watch.63dc3e33d70af548aa3773b17132e4e1.svg";
export { ForwardRef as ReactComponent };